import React from "react";
import * as clipboard from "clipboard-polyfill";
import * as xml2js from "xml2js";

import { MapNode } from "./map";
import s from "./more.module.scss";
import sMap from "./map.module.scss";
import { XML_OPTIONS } from "../xml-options";
import { background } from "@moai/core";

interface Props {
    name: string;
    node: MapNode;
    setFoo: (foo: null | boolean) => void;
}

const sanitize = (_node: MapNode, _name: string): object => {
    const nameNum = Number(_name);
    // @TODO: https://github.com/dvkndn/toolkit/issues/10
    const name = isNaN(nameNum) ? _name : `item${_name}`;
    // @TODO: we may not always really need to wrap?
    const node = { [name]: _node };
    // @TODO: same as #10, we need beter name (e.g. parent name)
    if (Array.isArray(_node)) return { [`${name}array`]: node };
    return node;
};

const xmlBuilder = new xml2js.Builder(XML_OPTIONS);

export const MoreButton: React.FC<Props> = ({ name, node, setFoo }) => {
    const copy = React.useCallback(() => {
        try {
            const snode = sanitize(node, name);
            const text = xmlBuilder.buildObject(snode);
            clipboard.writeText(text);
        } catch (e) {
            window.alert(`Cannot copy: ${e.message}`);
        }
    }, [node, name]);

    const expand = React.useCallback(() => {
        setFoo(true);
        window.setTimeout(() => setFoo(null), 500);
    }, [setFoo]);

    const collapse = React.useCallback(() => {
        setFoo(false);
        window.setTimeout(() => setFoo(null), 500);
    }, [setFoo]);

    const onChange = React.useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            switch (e.target.value) {
                case "copy":
                    return copy();
                case "expand":
                    return expand();
                case "collapse":
                    return collapse();
                default:
                    throw Error(`Unknown target: ${e.target.value}`);
            }
        },
        [copy, expand, collapse]
    );

    return (
        <select
            onChange={onChange}
            value="default"
            // select needs explicit background set for the menu
            className={`${s.more} ${sMap.more} ${background.primary}`}
        >
            <option value="default">…</option>
            <option value="copy">Copy</option>
            <option value="expand">Expand all</option>
            <option value="collapse">Collapse all</option>
        </select>
    );
};
